import { Dropdown } from "./Dropdown";
import { useCustomerUsersCustomers } from "@api/hooks";

interface Props {
	onChange: (value: string, index?: number) => any;
	value: string;
	className?: string;
}

export const CustomersDropDown: React.FC<Props> = ({ value, onChange, className }) => {
	const { customers } = useCustomerUsersCustomers();

	return (
		<Dropdown<{ label: string; value: string }, string>
			options={[
				{
					label: "Alla enheter",
					value: "",
				},
				...((customers?.customers || []).flatMap((item: any) => ({
					label: item.name || "",
					value: item.id,
				})) || []),
			]}
			optionToLabel={(o) => o.label}
			optionToValue={(o) => o.value}
			selectedOptionPredicate={(val, option) => val[0] === option.value}
			onChange={(val, i) => onChange(val[0], i)}
			value={[value]}
			className={className}
		/>
	);
};
